const column = [
  {
    name:'首页',
    to:'/',
    type:1,//栏目type 1点击页内跳转 2栏目归类，下有子栏目 3打开新页面跳转
    children:[
      {
        name:'专业介绍',
        to:'/desc',
        type:1,
        params:{
          id:56
        },
      },
    ],
    params:{},
    img:'',
    introduce:''
  },
  {
    name:'学院概况',
    to:'',
    type:2,
    img:'b01.jpg',
    introduce:'坚持“高端引领、双轮驱动、融合发展、质量强校”的办学方针',
    children:[
      {
        name:'学院简介',
        to:'/evn/content',
        type:1,
        params:{
          id:8
        },
      },
      {
        name:'现任领导',
        to:'/evn/list',
        type:2,
        params:{
          id:11,
          template:'teacher'
        },
      },
      {
        name:'组织机构',
        to:'/evn/content',
        type:1,
        params:{
          id:7
        },
      },
      {
        name:'办学理念',
        to:'/evn/content',
        type:1,
        params:{
          id:0
        },
      },
      {
        name:'规章制度',
        to:'/evn/list',
        type:2,//列表也
        params:{
          id:14,
          template:'media'
        },
      },
      {
        name:'交通指引',
        to:'/evn/content',
        type:1,
        params:{
          id:151
        },
      },
      {
        name:'学院宣传片',
        to:'/evn/content',
        type:1,
        params:{
          id:330
        },
      },
      {
        name:'学院风光',
        to:'/evn/list',
        type:2,
        params:{
          id:17,
          template:'nev'
        },
      },
    ],
  },
  {
    name:'学院动态',
    to:'',
    type:2,
    img:'b02.jpg',
    introduce:'坚持“高端引领、双轮驱动、融合发展、质量强校”的办学方针',
    children:[
      {
        name:'校园新闻',
        to:'/evn/list',
        type:2,
        params:{
          id:18,
          template:'xnews'
        },
      },
      {
        name:'通知公告',
        to:'/evn/list',
        type:2,
        params:{
          id:19,
          template:'notice'
        },
      },
      {
        name:'媒体聚焦',
        to:'/evn/list',
        type:2,
        params:{
          id:20,
          template:'media'
        },
      },
      {
        name:'招标公告',
        to:'/evn/list',
        type:2,
        params:{
          id:58,
          template:'media'
        },
      },
      {
        name:'就业信息',
        to:'/evn/list',
        type:2,
        params:{
          id:64,
          template:'media'
        },
      },
      {
        name:'人才招聘',
        to:'/evn/list',
        type:2,
        params:{
          id:57,
          template:'media'
        },
      },
    ],
  },
  {
    name:'党建思政',
    to:'',
    type:2,
    img:'b03.jpg',
    introduce:'坚持“高端引领、双轮驱动、融合发展、质量强校”的办学方针',
    children:[
      {
        name:'党建在线',
        to:'/evn/list',
        type:2,
        params:{
          id:21,
          template:'media'
        },
      },
    ],
  },
  {
    name:'教育教学',
    to:'',
    type:2,
    img:'b04.jpg',
    introduce:'坚持“高端引领、双轮驱动、融合发展、质量强校”的办学方针',
    children:[
      {
        name:'人才培养',
        to:'/evn/list',
        type:2,
        params:{
          id:22,
          template:'media'
        },
      },
      {
        name:'政策文件',
        to:'/evn/list',
        type:2,
        params:{
          id:23,
          template:'media'
        },
      },
      {
        name:'教学动态',
        to:'/evn/list',
        type:2,
        params:{
          id:24,
          template:'media'
        },
      },
      {
        name:'规章制度',
        to:'/evn/list',
        type:2,
        params:{
          id:26,
          template:'media'
        },
      },
      {
        name:'教学信息',
        to:'/evn/list',
        type:2,
        params:{
          id:27,
          template:'media'
        },
      },
      {
        name:'文件下载',
        to:'/evn/list',
        type:2,
        params:{
          id:28,
          template:'file',
        },
      },
      {
        name:'双创与竞赛',
        to:'/evn/list',
        type:2,
        params:{
          id:29,
          template:'media'
        },
      },
      {
        name:'资源建设',
        to:'/evn/list',
        type:2,
        params:{
          id:30,
          template:'media'
        },
      },
      {
        name:'师资队伍',
        to:'/evn/list',
        type:2,
        params:{
          id:32,
          template:'media'
        },
      },
    ],
  },
  {
    name:'招生就业',
    to:'/enroll',
    type:2,//栏目type 1点击页内跳转 2栏目归类，下有子栏目 3打开新页面跳转
    children:[
      {
        name:'高中起点',
        to:'/evn/list',
        type:2,
        params:{
          id:69,
          template:'media'
        },
      },{
        name:'初中起点',
        to:'/enroll',
        type:1,
        // params:{
        //   id:522,
        // },
      },
    ],
    params:{},
    introduce:'坚持“高端引领、双轮驱动、融合发展、质量强校”的办学方针',
    img:'b05.jpg',
  },
  {
    name:'学工在线',
    to:'',
    type:2,
    img:'b06.jpg',
    introduce:'坚持“高端引领、双轮驱动、融合发展、质量强校”的办学方针',
    children:[
      {
        name:'学工动态',
        to:'/evn/list',
        type:2,
        params:{
          id:33,
          template:'media'
        },
      },
      {
        name:'院系风采',
        to:'/evn/list',
        type:2,
        params:{
          id:34,
          template:'media'
        },
      },
      {
        name:'社团风采',
        to:'/evn/list',
        type:2,
        params:{
          id:35,
          template:'media'
        },
      },
      {
        name:'院校文化',
        to:'/evn/list',
        type:2,
        params:{
          id:36,
          template:'media'
        },
      },
      {
        name:'党团建设',
        to:'/evn/list',
        type:2,
        params:{
          id:37,
          template:'media'
        },
      },
      {
        name:'规章制度',
        to:'/evn/list',
        type:2,
        params:{
          id:38,
          template:'media'
        },
      },
      {
        name:'心理健康',
        to:'/evn/list',
        type:2,
        params:{
          id:39,
          template:'media'
        },
      },
      {
        name:'校园之星',
        to:'/evn/list',
        type:2,
        params:{
          id:40,
          template:'star'
        },
      },
    ],
  },
  {
    name:'产业赋能',
    to:'',
    type:2,
    img:'b07.jpg',
    introduce:'坚持“高端引领、双轮驱动、融合发展、质量强校”的办学方针',
    children:[
      {
        name:'技能培训',
        to:'/evn/list',
        type:2,
        params:{
          id:41,
          template:'media'
        },
      },
      {
        name:'技能鉴定',
        to:'/evn/list',
        type:2,
        params:{
          id:42,
          template:'media'
        },
      },
      {
        name:'公共实训',
        to:'/evn/list',
        type:2,
        params:{
          id:43,
          template:'media'
        },
      },
      {
        name:'技师研修',
        to:'/evn/list',
        type:2,
        params:{
          id:44,
          template:'media'
        },
      },
      {
        name:'学历提升',
        to:'/evn/list',
        type:2,
        params:{
          id:45,
          template:'media'
        },
      },
      {
        name:'创新孵化',
        to:'/evn/list',
        type:2,
        params:{
          id:46,
          template:'media'
        },
      },
      {
        name:'竞赛集训',
        to:'/evn/list',
        type:2,
        params:{
          id:47,
          template:'media'
        },
      },
      {
        name:'产教融合',
        to:'/evn/list',
        type:2,
        params:{
          id:48,
          template:'newx'
        },
      },
      {
        name:'实训实习',
        to:'/evn/list',
        type:2,
        params:{
          id:67,
          template:'newx'
        },
      },

    ],
  },
  {
    name:'水蕴匠心',
    to:'/',
    type:1,//栏目type 1点击页内跳转 2栏目归类，下有子栏目 3打开新页面跳转
    children:[],
    params:{},
    img:'b08.jpg',
    introduce:''
  },
  {
    name:'公共服务',
    to:'',
    type:9,
    img:'',
    introduce:'坚持“高端引领、双轮驱动、融合发展、质量强校”的办学方针',
    children:[
      {
        name:'学期日历',
        to:'/evn/list',
        type:2,
        params:{
          id:61,
          template:'media'
        },
      },
    ],
  },
];

const enrollColumn = [
  {
    name:'本站首页',
    to:'/enroll/index',
    type:1,//栏目type 1点击页内跳转 2栏目归类，下有子栏目 3打开新页面跳转
    children:[],
    params:{},
    img:'',
    introduce:''
  },
  {
    name:'学院概况',
    to:'/evn/content?id=0&pid=1',
    type:1,
    children:[],
    img:'',
    introduce:'',
    params:{
      id:0
    },
  },
  {
    name:'招生信息',
    to:'',
    type:2,
    img:'',
    introduce:'',
    status:0,
    params:{
      id:0
    },
    children:[
      {
        name:'招生计划',
        to:'/enroll/article/list',
        type:1,
        params:{
          category_id:3
        },
      },
      {
        name:'收费一览',
        to:'/enroll/article/content',
        type:1,
        params:{
          article_id:18
        },
      },
      {
        name:'录取程序',
        to:'/enroll/article/content',
        type:1,
        params:{
          article_id:2
        },
      },
      {
        name:'证书样本',
        to:'/enroll/article/content',
        type:1,
        params:{
          article_id:16
        },
      },
    ],
  },
  {
    name:'招生动态',
    to:'/enroll/article/list',
    type:1,
    img:'',
    introduce:'',
    children:[],
    params:{
      category_id:7
    },
  },
  {
    name:'网上报名',
    to:'/sign',
    type:3,
    img:'',
    introduce:'',
    children:[],
    params:{
      category_id:8
    },
  },
  {
    name:'常见问答',
    to:'/enroll/article/list',
    type:1,
    img:'',
    introduce:'',
    children:[],
    params:{
      category_id:9
    },
  },
  {
    name:'资料下载',
    to:'/enroll/article/list',
    type:1,
    img:'',
    introduce:'',
    children:[],
    params:{
      category_id:10
    },
  },
  {
    name:'联系我们',
    to:'/enroll/article/content',
    type:1,
    img:'',
    introduce:'',
    children:[],
    params:{
      article_id:13
    },
  },
  {
    name:'学院首页',
    to:'/',
    type:1,//栏目type 1点击页内跳转 2栏目归类，下有子栏目 3打开新页面跳转
    children:[],
    params:{
    },
    img:'',
    introduce:''
  },
];
export default {
  column,
  enrollColumn
}



// WEBPACK FOOTER //
// ./src/utils/params.js